/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EffectiveAnnualCostFigures
 */
export interface EffectiveAnnualCostFigures {
    /**
     * 
     * @type {number}
     * @memberof EffectiveAnnualCostFigures
     */
    oneYear: number;
    /**
     * 
     * @type {number}
     * @memberof EffectiveAnnualCostFigures
     */
    threeYears: number;
    /**
     * 
     * @type {number}
     * @memberof EffectiveAnnualCostFigures
     */
    fiveYears: number;
    /**
     * 
     * @type {number}
     * @memberof EffectiveAnnualCostFigures
     */
    tenYears: number;
    /**
     * 
     * @type {number}
     * @memberof EffectiveAnnualCostFigures
     */
    chargesYearToMaturity: number;
}

/**
 * Check if a given object implements the EffectiveAnnualCostFigures interface.
 */
export function instanceOfEffectiveAnnualCostFigures(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "oneYear" in value;
    isInstance = isInstance && "threeYears" in value;
    isInstance = isInstance && "fiveYears" in value;
    isInstance = isInstance && "tenYears" in value;
    isInstance = isInstance && "chargesYearToMaturity" in value;

    return isInstance;
}

export function EffectiveAnnualCostFiguresFromJSON(json: any): EffectiveAnnualCostFigures {
    return EffectiveAnnualCostFiguresFromJSONTyped(json, false);
}

export function EffectiveAnnualCostFiguresFromJSONTyped(json: any, ignoreDiscriminator: boolean): EffectiveAnnualCostFigures {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'oneYear': json['OneYear'],
        'threeYears': json['ThreeYears'],
        'fiveYears': json['FiveYears'],
        'tenYears': json['TenYears'],
        'chargesYearToMaturity': json['ChargesYearToMaturity'],
    };
}

export function EffectiveAnnualCostFiguresToJSON(value?: EffectiveAnnualCostFigures | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'OneYear': value.oneYear,
        'ThreeYears': value.threeYears,
        'FiveYears': value.fiveYears,
        'TenYears': value.tenYears,
        'ChargesYearToMaturity': value.chargesYearToMaturity,
    };
}

